module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    class: _vm.bullet ? _vm.bullet : ''
  }, _vm._l((_vm.lista), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item)
      }
    })])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a8aab98","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ui-list.vue
// module id = 944
// module chunks = 1